<template>
	<div class="coupon-container" v-loading="loading">
		<template v-if="couponList.length > 0">
			<div class="coupon-list" :class="{ 'coupon-list-box-overdue': useStatus == 1 }">
				<div class="list">
					<div class="coupon-box" v-for="(item, index) in couponList" :key="index">
						<div class="coupon-info">
							<div class="left-box">
								<div class="name">
									{{ item.name }}
								</div>
								<div class="time" v-if="item.enableStartTime && item.enableStartTime">
									使用时间:{{ item.enableStartTime.split(" ")[0] }}~{{
                    item.enableEndTime.split(" ")[0]
                  }}
								</div>
							</div>
							<div class="right-box">
								<div class="money">
									￥<span>{{ parseFloat(item.amount) }}</span>
								</div>
								<div class="minPoint">
									满￥{{ parseFloat(item.minPoint) }}使用
								</div>
							</div>
						</div>
						<div class="bottom-box" v-if="useStatus == 0 || (useStatus == 1 && item.note)">
							<div class="btn-bottom" @click="handleShowRule(item, index)"
								:style="{ justifyContent: item.note ? '' : 'flex-end' }">
								<div class="rule" v-if="item.note">
									●查看使用规则
									<div class="iconfont icon-gengduo"></div>
								</div>
								<!-- haveType 0可领取;1可使用 -->
								<div class="btn" v-if="useStatus == 0" @click.stop="handleUse(item, index)">
									立即使用
								</div>
							</div>
							<div class="rule-box" v-if="item.showRule">
								{{ item.note }}
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="pagination-box">
				<el-pagination layout="prev, pager, next" :total="total" @current-change="handleCurrent"
					:current-page="pageNum" :page-size="15">
				</el-pagination>
			</div>
		</template>
		<el-empty v-if="couponList.length == 0" description="暂无优惠券"></el-empty>
	</div>
</template>

<script>
	import Cookies from "js-cookie";
	import {
		userAllCoupon
	} from "@/api/home.js";
	export default {
		props: {
			useStatus: {
				type: String,
				default: "",
			},
		},
		data() {
			return {
				couponList: [],
				loading: false,
				pageNum: 1,
				total: 0,
			};
		},
		beforeMount() {
			if (Cookies.get("couponListData")) {
				let couponListData = JSON.parse(Cookies.get("couponListData"));
				this.pageNum = couponListData.pageNum;
				this.useStatus = couponListData.useStatus;
				Cookies.remove("couponListData");
			}
			this.getCouponList();
		},
		methods: {
			handleShowRule(item, index) {
				this.$set(
					this.couponList[index],
					"showRule",
					!this.couponList[index].showRule
				);
				this.$forceUpdate();
			},
			handleCurrent(e) {
				this.pageNum = e;
				this.loading = true;
				this.getCouponList();
			},
			// 获取优惠券列表
			getCouponList() {
				this.loading = true;
				let params = {
					useStatus: this.useStatus,
					size: 15,
					current: this.pageNum,
				};
				userAllCoupon(params).then((result) => {
					this.loading = false;
					if (result && result.code == 0 && result.data?.records) {
						this.total = result.data.total;
						result.data.records.forEach((e) => {
							e.showRule = false;
						});
						this.couponList = result.data.records;
					} else if (result && result.msg) {
						this.$message({
							message: result.msg,
							type: "success",
						});
					} else {
						this.$message({
							message: "前方拥堵，请稍后再试...",
							type: "error",
						});
					}
				});
			},
			handleUse(item) {
				item.id = item.couponId;
				let params = {
					useStatus: this.useStatus,
					pageNum: this.pageNum,
				};
				Cookies.set("couponListData", params);
				if (item.type == 1) {
					Cookies.remove("goodsListData");
					window.sessionStorage.setItem("couponItem", JSON.stringify(item));
					this.$router.push("/goodsList?pageFrom=couponList&couponId=" + item.id);
				} else {
					this.$router.push("/home");
				}
			},
		},
	};
</script>

<style lang="scss">
	.coupon-container {
		width: 100%;

		.coupon-list {
			margin-bottom: 60px;

			.title {
				font-size: 24px;
				font-weight: 400;
				color: #262728;
			}

			.list {
				display: flex;
				flex-wrap: wrap;
			}
		}

		.coupon-list-box-overdue {
			filter: grayscale(100%);
			filter: gray;
		}

		.coupon-box {
			background: white;
			box-sizing: border-box;
			padding: 8px 14px 0;
			width: calc(33.3% - 7px);
			border-radius: 10px;
			position: relative;
			margin-bottom: 10px;
			margin-right: 10px;

			.coupon-info {
				display: flex;
				align-items: center;
				justify-content: space-between;
				padding: 14px 0;

				.left-box {
					.name {
						font-size: 14px;
						color: #2a2a2a;
						margin-bottom: 11px;
						font-weight: bold;
					}

					.time {
						font-size: 11px;
						color: #999999;
					}
				}

				.right-box {
					text-align: center;

					.money {
						color: #f51010;
						margin-top: -10px;
						font-size: 14px;

						span {
							font-size: 24px;
							font-weight: bold;
						}
					}

					.minPoint {
						font-size: 11px;
						color: #e88281;
						margin-top: 8px;
					}
				}
			}

			.bottom-box {
				border-top: 1px dashed #f0f0f0;
				box-sizing: border-box;
				padding-top: 7px;
				padding-bottom: 8px;
				overflow: hidden;

				.btn-bottom {
					display: flex;
					align-items: center;
					justify-content: space-between;
					color: #999999;
					font-size: 12px;

					overflow: hidden;

					.rule {
						display: flex;
						align-items: center;
						cursor: pointer;

						.iconfont {
							margin-left: 3px;
							width: 12px;
							height: 12px;
							line-height: 12px;
							text-align: center;
							font-size: 10px;
						}
					}

					.btn {
						width: 75px;
						height: 25px;
						background: #f65b13;
						border-radius: 13px;
						font-weight: 400;
						color: white;
						text-align: center;
						line-height: 25px;
						cursor: pointer;
					}
				}

				.rule-box {
					color: #888888;
					font-size: 13px;
					margin-top: 5px;
				}
			}
		}

		.coupon-box:nth-child(3n) {
			margin-right: 0;
		}

		.coupon-box::before,
		.coupon-box::after {
			position: absolute;
			content: "";
			background: #f5f5f5;
			width: 10px;
			height: 10px;
			border-radius: 50%;
			top: 88px;
		}

		.coupon-box::before {
			left: -5px;
		}

		.coupon-box::after {
			right: -5px;
		}

		.pagination-box {
			width: 100%;
			text-align: center;

			.el-pagination {
				margin: 50px auto;

				.btn-prev,
				.btn-next,
				.el-pager li {
					background: none !important;
					height: 28px;
					line-height: 28px;
					font-weight: 400;
				}

				.el-pager li.active {
					background: #fece36 !important;
					color: #262728;
					border-radius: 8px;
					min-width: 28px;
					font-weight: bold;
				}
			}
		}
	}
</style>